import React from 'react';
import type { SVGProps } from 'react';

const IconTriangle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="390"
    height="146"
    viewBox="0 0 390 146"
    fill="none"
    {...props}
  >
    <path d="M390 145.638V0L0 145.638H390Z" fill="currentColor" />
  </svg>
);

export default IconTriangle;
